import { EnrollmentContext } from "@/state";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { FC, useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useSelectedEnrollmentPlan } from "../hooks";

const ThemedP = styled.p`
  font-family: ${(props) => props.theme.font} !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  max-width: 165px;
`;

const PaddedShelf = styled(Shelf)`
  padding-top: 70px;
  padding-bottom: 70px;
`;

const LargeIcon = styled(Icon)`
  max-width: unset !important;
  max-height: unset !important;
  min-width: unset !important;
  min-height: unset !important;

  width: 30px;
  height: 30px;
`;

export const NeedHelp: FC = () => {
  const [state] = useContext(EnrollmentContext);
  const { customerServicePhoneNumber } = useSelectedEnrollmentPlan();
  const { t: translate } = useTranslation();

  if (customerServicePhoneNumber) {
    return (
      <PaddedShelf>
        <Shelf.Spacer />
        <Shelf>
          {state.experienceData.experience.identifier.toLowerCase() !== "l3harris" && (
            <>
              <LargeIcon color="lightgrey" size="regular" name="phone" />
              <ThemedP>
                {translate("NEED_HELP.contactUs")} {customerServicePhoneNumber}
              </ThemedP>
            </>
          )}
        </Shelf>
        <Shelf.Spacer />
      </PaddedShelf>
    );
  } else {
    return <></>;
  }
};
